import { render, staticRenderFns } from "./RewardChart.vue?vue&type=template&id=28139d2a"
import script from "./RewardChart.vue?vue&type=script&lang=js"
export * from "./RewardChart.vue?vue&type=script&lang=js"
import style0 from "./RewardChart.vue?vue&type=style&index=0&id=28139d2a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports